/**
 * A queue item's stored label or error as text. Items queued before 10/24
 * could hold the raw error object, which rendered as "[object Object]" on
 * Chris's phone (10/25); the server's detail or message is pulled out of it.
 */
export function describeQueueValue(value: unknown): string {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean')
    return String(value);
  const v = value as {
    detail?: unknown;
    message?: unknown;
    response?: { data?: { detail?: unknown }; status?: number };
    name?: unknown;
  };
  const detail = v.response?.data?.detail ?? v.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const parts = detail
      .map((d) => {
        const loc = Array.isArray(d?.loc)
          ? d.loc.filter((x: unknown) => x !== 'body').join('.')
          : '';
        return loc ? `${loc}: ${d?.msg ?? ''}` : String(d?.msg ?? '');
      })
      .filter(Boolean);
    if (parts.length) return parts.join('; ');
  }
  if (typeof v.message === 'string' && v.message) return v.message;
  if (typeof v.name === 'string' && v.name) return v.name;
  if (v.response?.status) return `Request failed (${v.response.status})`;
  try {
    return JSON.stringify(value).slice(0, 120);
  } catch {
    return 'Failed';
  }
}
